import { render, staticRenderFns } from "./SAPAPIDiagnostics.vue?vue&type=template&id=36c3c7c0&scoped=true"
import script from "./SAPAPIDiagnostics.vue?vue&type=script&lang=js"
export * from "./SAPAPIDiagnostics.vue?vue&type=script&lang=js"
import style0 from "./SAPAPIDiagnostics.vue?vue&type=style&index=0&id=36c3c7c0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c3c7c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c3c7c0')) {
      api.createRecord('36c3c7c0', component.options)
    } else {
      api.reload('36c3c7c0', component.options)
    }
    module.hot.accept("./SAPAPIDiagnostics.vue?vue&type=template&id=36c3c7c0&scoped=true", function () {
      api.rerender('36c3c7c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/SAPAPIDiagnostics.vue"
export default component.exports